export default __webpack_public_path__ + "static/media/rowSeat_mockup_light.ff1a1622.svg";